// project import
import Navigation from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';
// import Sidebar from './Navigation/Sidebar';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => (
  <SimpleBar
    sx={{
      '& .simplebar-content': {
        display: 'flex',
        flexDirection: 'column'
      }
    }}
  >
    <Navigation />
    {/* <Sidebar /> */}
  </SimpleBar>
);

export default DrawerContent;
